export default Object.freeze({
  User: 1,
  Position: 2,
  Area: 3,
  UserGroup: 4,
  UserGroupUser: 5,
  Environment: 6,
  EnvironmentUser: 7,
  Delegation: 8,
  DelegationConfiguration: 9,
  GlobalEntityApproverByAreas: 10,
  GlobalEntityApproverByPositions: 11,
  GlobalEntityApproverByUserGroups: 12,
  GlobalEntityApproverUsers: 13,
  GlobalUserGroupApproverByAreas: 14,
  GlobalUserGroupApproverByPositions: 15,
  GlobalUserGroupApproverUsers: 16,
  ReportTrace: 17,
  InternalTask: 18,
  ProcessInstance: 19,
  ChatThreadParticipant: 20,
});
